import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import styles from './Post.module.sass';

export const Post = () => {
  const postInfo = useSelector((state) => state.get('route').get('post'))?.toJS() || [];
  const [items, setItems] = useState([]);
  const [itemsOpen, setItemsOpen] = useState([]);

  useEffect(() => {
    const content = [];
    const contentOpen = [];
    postInfo.forEach((post, i) => {
      contentOpen.push(i);
      content.push({
        title: post.title,
        content: post.text,
        id: i,
      });
    });

    setItems(content);
    setItemsOpen(contentOpen);
  }, []);

  const handleOpen = (id) => () => {
    const idParsed = Number(id);

    if (itemsOpen.includes(idParsed)) {
      return setItemsOpen(itemsOpen.filter((item) => item !== idParsed));
    }

    setItemsOpen([...itemsOpen, idParsed]);
  };

  return (
    <div className={styles.Post}>
      {items?.map((item) => {
        const isOpen = itemsOpen.includes(item.id);
        return (
          <div className={styles.Accordion} key={item.title}>
            <button onClick={handleOpen(item.id)}>
              <h2>{item.title}</h2>
              <div>{isOpen ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
            </button>
            {isOpen && <div className={styles.AccordionContent} dangerouslySetInnerHTML={{ __html: item.content }} />}
          </div>
        );
      })}
    </div>
  );
};
